module.exports = __webpack_public_path__ + "static/img/产品中心-问煤-行业法规秒级检索.cb518dc9.png";